<template>
    <div>
        <div class="projects-container pT0" :class="{'p0':empDetailsarry && empDetailsarry.length == 0 || empDetailsarry == null}">
            <div class="project-title" v-if="empDetailsarry && empDetailsarry.length > 0 && empDetailsarry != null">
                <div class="text-left pull-left">
                    <h3 v-if="empDetailsarry && empDetailsarry.length > 0">Current Project<template v-if="empDetailsarry && empDetailsarry.length > 1">s</template></h3>
                </div>
                 <div class="text-right pull-right" v-if="loggedInUserObj.HireType =='W2'">
                    <ob-button type="primary" @click="selectTypeToAddProject" :disabled="loadingDetails">Add Project</ob-button>
                </div>
                <div class="clearfix"></div>
            </div>
            <template v-if="(empDetailsarry && empDetailsarry.length > 0)">
                <div class="current-project-block" v-for="(empDetails,index) in empDetailsarry" :key="index">
                  <current-project :empDetails="empDetails" @linkToEndClientPopupOpen="openLinkToEndClientPopup(empDetails,index)" :expantMode="index == 0 ? true : false" @isEmpdetailprojects="toEmpdetailprojects" @OnboardTax='isOnboardTax'></current-project>
                </div>               
            </template>       
        </div>
        <div class="projects-container" v-if="(prevProjectDetails != null) && (prevProjectDetails && prevProjectDetails.length > 0)"  :class="{'margin-top_20' : (empDetailsarry && empDetailsarry.length == 0)}">
            <div class="project-title">
                <div class="text-left pull-left"><h3>Previous Project<template v-if="(prevProjectDetails && prevProjectDetails.length > 0)">s</template></h3></div>
                <div class="text-right pull-right" v-if="(prevProjectDetails && prevProjectDetails.length > 0) && (empDetailsarry && empDetailsarry.length == 0) && loggedInUserObj.HireType =='W2'">
                    <ob-button  type="primary" @click="selectTypeToAddProject" :disabled="loadingDetails">Add Project</ob-button>
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="previous-projects-block" v-for="(p, index) in prevProjectDetails" :key="index">
                 <current-project :IsPreviousProject="true" :empDetails="p" @linkToEndClientPopupOpen="openLinkToEndClientPopup(p,index)" @isEmpdetailprojects="toEmpdetailprojects" @OnboardTax='isOnboardTax'></current-project>
            </div>
        </div>
        <div v-if="((empDetailsarry && empDetailsarry.length == 0 || empDetailsarry == null) && !loadingDetails && (prevProjectDetails && prevProjectDetails.length == 0 || prevProjectDetails == null))" style="position:relative;height:250px;">
            <div class="project-title empty-projectbtn" v-if="loggedInUserObj.HireType =='W2'">
                 <span class="btn-alert-projecttext">No project is added for you. Your HR will add the project, however, even you can add it.
                        </span>
                <div class="text-right pull-right">
                    <ob-button  type="primary" @click="selectTypeToAddProject">Add Project</ob-button>
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="no-candidates">
                <div class="pfa-body" style="display: table-cell; vertical-align: middle;text-align: center;">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/emptylist.png`" style="margin-bottom:20px;" /> 
                    <h5 class="pfa-info_msg">
                        No projects to display
                    </h5>
                </div>
            </div>
        </div> 
         <create-project-popup :openModal.sync="openCreateProject" :istaxOnboard ="taxOnboard" ></create-project-popup>
         <!-- :MasterProjects="false" -->
    </div>
</template>

<script>
    import CurrentProject from "./ESSProjects/EmpProjectsDocuments.vue"
    import CreateProjectPopup from "./ESSProjects/CreateProjectPopup.vue"
    
    export default {
        data() {
            return {
                currentLinkPopupIndex: 0,
                currentLinkPopupObj: null,

                loadingDetails: false,
                isOnboarded: true,
                prevProjectDetails: [],
                paramConsultantId: this.$route.params.id,
                empDetailsarry: [],
                openEndClientPopup: false,
                taxtermdetails: '',
                taxOnboard: '',

                //     options: {
                //        data:[

                //        ]
                //    },
                //    options1: {
                //        format: 'MM/DD/YYYY'
                //    },
                id: 4,
                idvendor: 4,
                tree: {
                    ClientDetails: [{
                            id: '1',
                            isDelete: false,
                            isAddAnotherClient: true,
                            isDisabledClient: true,
                            EndClientName: "FirstName",
                            EndClientWebsite: 'www.google.com',
                        },
                        {
                            id: '2',
                            isDelete: false,
                            isAddAnotherClient: true,
                            isDisabledClient: true,
                            EndClientName: "FirstName",
                            EndClientWebsite: 'www.google.com',
                        },
                        {
                            id: '3',
                            isDelete: false,
                            isAddAnotherClient: true,
                            isDisabledClient: true,
                            EndClientName: "FirstName",
                            EndClientWebsite: 'www.youtube.com',
                        }
                    ],
                    VendorDetails: [{
                            idvendor: '',
                            isAddVendor: true,
                            isDelete: false,
                            isDisabledVendor: true,
                            OrganizationName: "Google"
                        },
                        {
                            idvendor: '2',
                            isAddVendor: true,
                            isDelete: false,
                            isDisabledVendor: true,
                            OrganizationName: "youtube"
                        }
                    ],
                },
                openCreateProject: false,

            }
        },

        components: {
            "current-project": CurrentProject,
            "create-project-popup":CreateProjectPopup,
        },
        
        computed: {

        },
        
        watch: {

        },
        
        created() {
            this.$loading({
                'loadingText': 'Loading...'
            })
            this.getEmpDetails()
            events.listen("emp-details-updated",() =>{
                this.prevProjectDetails = []
                this.empDetailsarry = null
                this.getEmpDetails()
            })
        },
        
        methods: {
            isOnboardTax(f) {
                this.taxOnboard = f

            },
            toEmpdetailprojects() {
                this.prevProjectDetails = []
                this.empDetailsarry = []
                this.getEmpDetails()
            },
            getEmpDetails() {

                this.loadingDetails = true
                //${this.paramConsultantId}${loggedInUserObj.empId}
                ajax.get(`/Employee/${loggedInUserObj.consultantId}/GetEmployeeProjectDetail?orgId=${loggedInUserObj.orgId}&isESS=true`, {}, (res) => {
                    if (res.data.State == true) {
                        this.$loading({}).close()
                        this.isOnboarded = true
                        this.loadingDetails = false
                        // var x = []
                        // x = res.data.EmployeeDetail.EmployeeCurrentProject
                        this.empDetailsarry = res.data.EmployeeDetail.EmployeeCurrentProject

                        if (this.empDetailsarry && this.empDetailsarry.length > 0) {
                            this.empDetailsarry.forEach((c, index) => {
                                let sDate = `sDate${index}`
                                let eDate = `eDate${index}`
                                this.$set(c, 'updateFlag', false)
                                this.$set(c, 'sDate', sDate)
                                this.$set(c, 'eDate', eDate)
                                this.$set(c, 'isSending', false)
                                if (c.PayRate == 0) {
                                    c.PayRate = ''
                                }
                                c.StartDate = this.formatPrevDate(c.StartDateString)
                                c.EndDate = this.formatPrevDate(c.EndDateString)

                                if (this.IsNullOrEmpty(c.LayerDetails)) {
                                    c.LayerDetails = this.generateLayerInformation(c)
                                }
                            })
                        }
                        this.prevProjectDetails = res.data.EmployeeDetail.EmployeeProjectList
                        if (this.prevProjectDetails && this.prevProjectDetails.length > 0) {
                            this.prevProjectDetails.forEach((c, index) => {
                                let sDate = `psDate${index}`
                                let eDate = `peDate${index}`
                                this.$set(c, 'updateFlag', false)
                                this.$set(c, 'sDate', sDate)
                                this.$set(c, 'eDate', eDate)
                                this.$set(c, 'isSending', false)
                                if (c.PayRate == 0) {
                                    c.PayRate = ''
                                }
                                c.StartDate = this.formatPrevDate(c.StartDateString)
                                c.EndDate = this.formatPrevDate(c.EndDateString)


                                if (this.IsNullOrEmpty(c.LayerDetails)) {
                                    c.LayerDetails = this.generateLayerInformation(c)
                                }
                            })
                        }

                    } else {
                        this.loadingDetails = false
                        this.ESSEnableDisable(res)
                        this.isOnboarded = false
                    }

                })
            },
            formatPrevDate(val) {
                if (val != null && val != '' && val != '0001/01/01T00:00:00') {
                    return val
                }
            },

            // openLinkToEndClientPopup(empDetails,index) {
            //     this.currentLinkPopupIndex = index
            //     this.currentLinkPopupObj = empDetails
            //     this.tree = empDetails.LayerDetails
            //     this.taxtermdetails= empDetails.OnBoardHireType
            //     this.openEndClientPopup = true
            // },
            // openlinkToEndClientPopupOpenAdd(empDetails,index){
            //      let data=[{
            //             IsEdit:true,
            //             OrganizationName:empDetails.EndClientName,
            //             Type:"EndClient",
            //             Website:""
            //         },
            //         {
            //             IsEdit:true,
            //             OrganizationName:empDetails.ClientName,
            //             Type:"Client",
            //             Website:""
            //         },
            //         {
            //             IsEdit:false,
            //             OrganizationName:this.loggedInUserObj.OrgName,
            //             Type:"Self",
            //             Website:this.loggedInUserObj.OrgWebSite
            //         }

            //         ]
            //     this.currentLinkPopupIndex = index
            //     this.currentLinkPopupObj = empDetails
            //     this.tree = data
            //     this.taxtermdetails= empDetails.OnBoardHireType
            //     this.openEndClientPopup = true

            // },
            generateLayerInformation(empDetails) {

                let data = [{
                        IsEdit: true,
                        OrganizationName: empDetails.EndClientName,
                        Type: "EndClient",
                        Website: ""
                    },
                    {
                        IsEdit: true,
                        OrganizationName: empDetails.ClientName,
                        Type: "Client",
                        Website: ""
                    },
                    {
                        IsEdit: false,
                        OrganizationName: this.loggedInUserObj.OrgName,
                        Type: "Self",
                        Website: this.loggedInUserObj.OrgWebSite
                    }

                ]
                return data

            },

            selectTypeToAddProject() {
                this.openCreateProject = true
            }
        }
        
    } 
</script>
<style lang="scss">
@import "~styles/framework/vue-utils";
    .projects-container {
        padding:15px;
    }
    .previous-projects-block {
        margin-bottom:15px;
        .folder-header{
        background:#f7f7f7 !important;
        border:1px solid #c2c2c2 !important;
       }
      .folder-wrapper{
        border:1px solid #c2c2c2 !important;
      }
      .project-control-documents{
          border-bottom: 2px dashed #c2c2c2;
      }
      .folder-body{
       background:#fff !important;
      }
    }
    .project-title {
       border-bottom:1px dashed #ccc;
       margin:10px 0px;
       padding:10px 0px;
       h3{
             font-weight:600;
             color:#143361;
         }
    }
    .folder-header-heading{
        font-weight:600;
        margin-bottom:5px;
        color:#333;
    }
    .project-status {
        span{
            display:block;
        }
        .project-status--message{
            font-weight:600;
            color:#143361;
        }
    }
    .project-actions_btn{
        margin-top:10px;
        .dropdown-list-item{
         font-size:11px;
        }
    }

    .project-control-documents {
        border-bottom:2px dashed #4D92DF;
        padding:20px 0;
        h4{
            font-weight:600;
            color:#143361;
            display: inline-block;
            width: 50%;
        }
        td span{
            font-size:12px;
        }
        .headline{
            color:#777;
            display:inline-block;
            width:100%;
        }
        .headline-message {
            font-weight: 600;
            color: #143361;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            display: block;
        }
        table{
            tr{
                td{
                padding:10px 10px 10px 0px;
                }
            }
          }
        .ob-vuelidate_error-msg {
            position: absolute;
        }
    }

    .document-list__heading{
        border: 1px solid #1DC942;
        background: #f4fef7;
        padding: 5px 10px;
        display: inline-block;
        border-radius: 30px;
        font-weight: 600;
        span{
           display:inline-block;
        }
        .document-list__status{
            background: #a4f3b5;
            border-radius:100%;
            margin-left:3px;
        }
    }
    .project-list-filename {
        margin:5px 0;
        font-weight:500;
        color:#777;
    }
    .current-project-btn{
        padding:10px 0px;
        text-align:center;
    }
    .popper{
        font-size:12px !important;
    }
    .request-doc{
        display: flex;
        align-items: center;
        .request-btn{
            display: inline-block;
            margin-top: -5px;
            width: 50%;
            text-align: right;
         }
    }
   
    .add-project_link{
        color: #fff !important;
        background-color: #143361;
        border-color: #10284c;
        padding: 8px;
        font-size: 13px;
        border-radius: 5px;
        font-weight: 400;
    }
    .no-candidates{
        position:absolute;
        left:35%;
        top:100px;
        text-align:center;
        img{
            width: 150px;
        }
  
    }
    .current-project-block{
        padding:0 0 20px 0;
    }
    .margin-top_20{
        margin-top:-20px;
    }
    .empty-projectbtn{
        padding: 5px 15px;
        background: #ffe8c3;
    }
    .btn-projectright{
        float:right;        
    }
    .btn-alert-projecttext{
        font-weight: 600;
        color: #333;
        display: inline-block;
        transform: translatey(5px);
    }
    .current-project-block{
             .folder-body{
                  padding: 20px !important;
                 background: #fff !important;
             }

         }
         .no-project-data{
             font-size: 14px;
         }

    .pfa-body {
        padding: 15px;
        display: inline-block;
        .pfa-info_msg {
                color: $ob-brand-primary;
                font-size: 13px;
                line-height: 20px;
                margin: 0;
        }

    }   

</style>
<style lang="scss" scoped>
 .popper{
        padding: 11px 3px !important;
        width: 153px !important;
    }
    .dropdown-list-item{
        margin-left:5px;
    }
</style>




// WEBPACK FOOTER //
// src/components/ESSProfile/EmpProjects.vue